// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"AlertCall_mainContainer__ORmlu","img":"AlertCall_img__15Sl9","fabContainer":"AlertCall_fabContainer__1IHiq"};